/* BIÉDE FIND YOUR ELEMENT v2026-08-08-1 */
/* BIÉDE FIND YOUR ELEMENT interface fix v2026-08-09-1 */

(() => {
  const ROOT_SELECTOR = '[data-biede-find-your-element]';
  const MOBILE_QUERY = '(max-width: 749px)';

  const normalizeCode = (value) => String(value || '').trim().toUpperCase().replaceAll('.', '');

  const makeElement = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined && text !== null) element.textContent = text;
    return element;
  };

  class BiedeFindYourElement {
    constructor(root) {
      this.root = root;
      this.config = this.readJson(root.querySelector('[data-biede-fye-config]')) || { labels: {} };
      this.labels = this.config.labels || {};
      this.cards = [...root.querySelectorAll('[data-biede-element-card]')];
      this.models = this.cards
        .map((card) => {
          const model = this.readJson(card.querySelector('[data-biede-element-data]'));
          if (!model || !model.id) return null;
          model.card = card;
          return model;
        })
        .filter(Boolean)
        .sort((a, b) => Number(a.order) - Number(b.order));
      this.models.forEach((model) => {
        model.selectedEdition = this.primaryEdition(model);
      });
      this.modelMap = new Map(this.models.map((model) => [normalizeCode(model.id), model]));
      this.activeFilters = {
        use: 'ALL',
        carry: 'ALL',
        device: 'ALL',
        size: 'ALL',
        model: 'ALL'
      };
      this.selected = new Set();
      this.mobileQuery = window.matchMedia(MOBILE_QUERY);
      this.nextImageRequest = 0;

      this.filterCount = root.querySelector('[data-biede-filter-count]');
      this.noResults = root.querySelector('[data-biede-no-results]');
      this.compareStatus = root.querySelector('[data-biede-compare-status]');
      this.comparison = root.querySelector('[data-biede-comparison]');
      this.nextGrid = root.querySelector('[data-biede-next-grid]');
      this.nextMedia = root.querySelector('[data-biede-next-media]');
      this.nextImage = root.querySelector('[data-biede-next-image]');
      this.ownedSelect = root.querySelector('[data-biede-owned-select]');
      this.nextResult = root.querySelector('[data-biede-next-result]');

      if (!this.models.length) return;
      this.enableInteractiveControls();
      this.bindEvents();
      this.renderFilters();
      this.renderComparison();
      this.renderOwnedOptions();
    }

    readJson(node) {
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        console.warn('BIÉDE FIND YOUR ELEMENT: invalid JSON data.', error);
        return null;
      }
    }

    enableInteractiveControls() {
      this.root.querySelectorAll('[data-biede-filter-controls], [data-biede-compare-controls]').forEach((node) => {
        node.hidden = false;
      });
      this.root.querySelectorAll('[data-biede-compare-toggle]').forEach((button) => {
        button.hidden = false;
      });
      this.root.querySelectorAll('[data-biede-edition-select]').forEach((control) => {
        control.setAttribute('role', 'button');
        control.setAttribute('aria-pressed', String(control.getAttribute('aria-current') === 'true'));
      });
      if (this.nextGrid) this.nextGrid.hidden = false;
    }

    bindEvents() {
      this.root.addEventListener('click', (event) => {
        const filterButton = event.target.closest('[data-filter-axis] [data-filter-value]');
        if (filterButton && this.root.contains(filterButton)) {
          const group = filterButton.closest('[data-filter-axis]');
          this.setFilter(group.dataset.filterAxis, filterButton.dataset.filterValue);
          return;
        }

        const compareButton = event.target.closest('[data-biede-compare-toggle]');
        if (compareButton && this.root.contains(compareButton)) {
          this.toggleCompare(compareButton.dataset.biedeCompareToggle);
          return;
        }

        const editionControl = event.target.closest('[data-biede-edition-select]');
        if (editionControl && this.root.contains(editionControl)) {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.selectEdition(editionControl);
          return;
        }

        const compareRemove = event.target.closest('[data-biede-compare-remove]');
        if (compareRemove && this.root.contains(compareRemove)) {
          const removedId = normalizeCode(compareRemove.dataset.biedeCompareRemove);
          this.selected.delete(removedId);
          this.renderCompareButtons();
          this.renderComparison();
          const comparisonRegion = this.comparison?.querySelector('.biede-fye__compare-table-wrap');
          if (comparisonRegion) {
            comparisonRegion.focus();
          } else {
            this.comparison.tabIndex = -1;
            this.comparison.focus();
          }
          return;
        }

        if (event.target.closest('[data-biede-filter-clear]')) {
          this.clearFilters();
          return;
        }

        if (event.target.closest('[data-biede-compare-clear]')) {
          this.selected.clear();
          this.renderCompareButtons();
          this.renderComparison();
        }
      });

      this.root.addEventListener('keydown', (event) => {
        if (event.key !== ' ') return;
        const editionControl = event.target.closest('[data-biede-edition-select]');
        if (!editionControl || !this.root.contains(editionControl)) return;
        event.preventDefault();
        editionControl.click();
      });

      if (this.ownedSelect) {
        this.ownedSelect.addEventListener('change', () => this.renderNext());
      }

      const onMediaChange = () => this.renderComparison();
      if (typeof this.mobileQuery.addEventListener === 'function') {
        this.mobileQuery.addEventListener('change', onMediaChange);
      } else if (typeof this.mobileQuery.addListener === 'function') {
        this.mobileQuery.addListener(onMediaChange);
      }
    }

    setFilter(axis, value) {
      if (!(axis in this.activeFilters)) return;
      this.activeFilters[axis] = normalizeCode(value) || 'ALL';
      const group = this.root.querySelector(`[data-filter-axis="${axis}"]`);
      group?.querySelectorAll('[data-filter-value]').forEach((button) => {
        button.setAttribute('aria-pressed', String(normalizeCode(button.dataset.filterValue) === this.activeFilters[axis]));
      });
      this.renderFilters();
    }

    clearFilters() {
      Object.keys(this.activeFilters).forEach((axis) => {
        this.activeFilters[axis] = 'ALL';
      });
      this.root.querySelectorAll('[data-filter-axis]').forEach((group) => {
        group.querySelectorAll('[data-filter-value]').forEach((button) => {
          button.setAttribute('aria-pressed', String(normalizeCode(button.dataset.filterValue) === 'ALL'));
        });
      });
      this.renderFilters();
    }

    matchesFilter(model, axis, activeValue) {
      if (activeValue === 'ALL') return true;
      if (axis === 'carry' && activeValue === 'MULTIWAY') {
        return (model.carryCodes || []).length > 1;
      }
      const values = {
        use: model.useCodes,
        carry: model.carryCodes,
        device: model.deviceCodes,
        size: [model.sizeCode],
        model: [model.id]
      }[axis] || [];
      return values.map(normalizeCode).includes(activeValue);
    }

    renderFilters() {
      let visibleCount = 0;
      this.models.forEach((model) => {
        const visible = Object.entries(this.activeFilters).every(([axis, value]) => this.matchesFilter(model, axis, value));
        model.card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (this.filterCount) {
        this.filterCount.textContent = `${visibleCount} / ${this.models.length} ${this.labels.models || 'MODELS'}`;
      }
      if (this.noResults) this.noResults.hidden = visibleCount !== 0;
    }

    maxSelection() {
      return this.mobileQuery.matches ? 2 : 3;
    }

    toggleCompare(id) {
      const normalizedId = normalizeCode(id);
      if (!this.modelMap.has(normalizedId)) return;

      if (this.selected.has(normalizedId)) {
        this.selected.delete(normalizedId);
      } else if (this.selected.size < this.maxSelection()) {
        this.selected.add(normalizedId);
      } else {
        if (this.compareStatus) {
          this.compareStatus.textContent = this.mobileQuery.matches
            ? this.labels.limitMobile
            : this.labels.limitDesktop;
        }
        return;
      }

      this.renderCompareButtons();
      this.renderComparison();
    }

    renderCompareButtons() {
      this.models.forEach((model) => {
        const button = model.card.querySelector('[data-biede-compare-toggle]');
        if (!button) return;
        const isSelected = this.selected.has(normalizeCode(model.id));
        button.setAttribute('aria-pressed', String(isSelected));
        button.textContent = isSelected ? this.labels.addedCompare : this.labels.addCompare;
      });
    }

    primaryEdition(model) {
      return model.editions?.find((edition) => edition.primary)
        || model.editions?.find((edition) => edition.available)
        || model.editions?.[0]
        || null;
    }

    currentEdition(model) {
      return model.selectedEdition || this.primaryEdition(model);
    }

    selectEdition(control) {
      const card = control.closest('[data-biede-element-card]');
      const model = card ? this.modelMap.get(normalizeCode(card.dataset.model)) : null;
      if (!model) return;
      const edition = model.editions?.find((item) => item.url === control.dataset.biedeEditionSelect);
      if (!edition) return;

      model.selectedEdition = edition;
      card.querySelectorAll('[data-biede-edition-select]').forEach((item) => {
        const isSelected = item.dataset.biedeEditionSelect === edition.url;
        item.setAttribute('aria-pressed', String(isSelected));
        if (isSelected) {
          item.setAttribute('aria-current', 'true');
        } else {
          item.removeAttribute('aria-current');
        }
      });

      const image = card.querySelector('.biede-element-card__media img');
      if (image && edition.image) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = edition.image;
        image.alt = edition.imageAlt || edition.title || model.name;
      }
      const kicker = card.querySelector('[data-biede-card-kicker]');
      const title = card.querySelector('[data-biede-card-title]');
      const price = card.querySelector('[data-biede-card-price]');
      const detailLink = card.querySelector('[data-biede-card-link]');
      if (kicker) kicker.textContent = edition.number || '';
      if (title) title.textContent = edition.title || model.name;
      if (price) price.textContent = edition.price || '';
      if (detailLink && edition.url) detailLink.href = edition.url;

      if (this.selected.has(normalizeCode(model.id))) this.renderComparison();
    }

    renderComparison() {
      if (!this.comparison) return;
      const chosen = [...this.selected].map((id) => this.modelMap.get(id)).filter(Boolean);
      const max = this.maxSelection();

      if (this.compareStatus) {
        if (this.mobileQuery.matches && chosen.length > max) {
          this.compareStatus.textContent = this.labels.overMobile;
        } else {
          this.compareStatus.textContent = `${chosen.length} / ${max} ${this.labels.compareSelected || ''}`.trim();
        }
      }

      this.comparison.replaceChildren();
      if (!chosen.length) {
        this.comparison.append(makeElement('p', 'biede-fye__compare-empty', this.labels.compareEmpty));
        return;
      }

      const wrap = makeElement('div', 'biede-fye__compare-table-wrap');
      wrap.tabIndex = 0;
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('aria-label', this.labels.tableLabel || 'ELEMENT comparison');
      const table = makeElement('table', 'biede-fye__compare-table');
      const caption = makeElement('caption', 'biede-fye__visually-hidden', this.labels.tableLabel || 'ELEMENT comparison');
      table.append(caption);
      const thead = document.createElement('thead');
      const headRow = document.createElement('tr');
      const corner = makeElement('th', '', this.labels.element);
      corner.scope = 'col';
      headRow.append(corner);

      chosen.forEach((model) => {
        const edition = this.currentEdition(model);
        const cell = makeElement('th', 'biede-fye__compare-product');
        cell.scope = 'col';
        if (edition?.image) {
          const image = document.createElement('img');
          image.src = edition.image;
          image.alt = '';
          image.loading = 'lazy';
          cell.append(image);
        }
        const name = makeElement('strong', '', edition?.title || model.name);
        cell.append(name);
        if (edition?.price) cell.append(makeElement('span', '', edition.price));
        const remove = makeElement('button', 'biede-fye__compare-remove', this.labels.remove || 'REMOVE');
        remove.type = 'button';
        remove.dataset.biedeCompareRemove = model.id;
        remove.setAttribute('aria-label', `${this.labels.remove || 'REMOVE'} ${model.name}`);
        cell.append(remove);
        headRow.append(cell);
      });
      thead.append(headRow);
      table.append(thead);

      const rows = [
        [this.labels.size, (model) => model.dimensions],
        [this.labels.weight, (model) => model.weight],
        [this.labels.carry, (model) => model.carry],
        [this.labels.device, (model) => model.device],
        [this.labels.opening, (model) => model.opening],
        [this.labels.pockets, (model) => model.pockets],
        [this.labels.fits, (model) => model.fits],
        [this.labels.bestFor, (model) => model.bestFor]
      ];
      const tbody = document.createElement('tbody');
      rows.forEach(([label, getter]) => {
        const row = document.createElement('tr');
        const heading = makeElement('th', '', label);
        heading.scope = 'row';
        row.append(heading);
        chosen.forEach((model) => row.append(makeElement('td', '', getter(model) || '—')));
        tbody.append(row);
      });

      const detailRow = document.createElement('tr');
      const detailHeading = makeElement('th', '', this.labels.detail);
      detailHeading.scope = 'row';
      detailRow.append(detailHeading);
      chosen.forEach((model) => {
        const cell = document.createElement('td');
        const edition = this.currentEdition(model);
        if (edition?.url) {
          const link = makeElement('a', '', `${this.labels.viewDetail} →`);
          link.href = edition.url;
          cell.append(link);
        } else {
          cell.textContent = '—';
        }
        detailRow.append(cell);
      });
      tbody.append(detailRow);
      table.append(tbody);
      wrap.append(table);
      this.comparison.append(wrap);
    }

    renderOwnedOptions() {
      if (!this.ownedSelect) return;
      const options = this.models.map((model) => {
        const option = document.createElement('option');
        option.value = model.id;
        option.textContent = model.name;
        return option;
      });
      this.ownedSelect.replaceChildren(...options);
      const neko = this.models.find((model) => normalizeCode(model.id) === 'NEKO');
      this.ownedSelect.value = neko?.id || this.models[0].id;
      this.renderNext();
    }

    nextTarget(owned) {
      const adminCode = normalizeCode(owned.adminNextCode);
      if (adminCode && this.modelMap.has(adminCode)) {
        const matchesFallback = adminCode === normalizeCode(owned.fallbackNextCode);
        return {
          model: this.modelMap.get(adminCode),
          reason: owned.adminNextReason || (matchesFallback ? owned.fallbackNextCopy : this.labels.nextGeneric)
        };
      }

      const fallbackCode = normalizeCode(owned.fallbackNextCode);
      if (fallbackCode && this.modelMap.has(fallbackCode)) {
        return {
          model: this.modelMap.get(fallbackCode),
          reason: owned.fallbackNextCopy || this.labels.nextGeneric
        };
      }
      return null;
    }

    renderNext() {
      if (!this.ownedSelect || !this.nextResult) return;
      const owned = this.modelMap.get(normalizeCode(this.ownedSelect.value));
      const target = owned ? this.nextTarget(owned) : null;
      this.nextResult.replaceChildren();

      if (!target) {
        this.nextResult.append(makeElement('p', '', this.labels.nextGeneric));
        this.renderNextImage(null);
        return;
      }

      const edition = this.primaryEdition(target.model);
      const eyebrow = makeElement(
        'p',
        'biede-fye__next-result-eyebrow',
        `${this.labels.nextEyebrow}${edition?.number ? ` / ${edition.number}` : ''}`
      );
      const title = makeElement('h3', '', edition?.title || target.model.name);
      const reason = makeElement('p', '', target.reason);
      this.nextResult.append(eyebrow, title, reason);

      if (edition?.url) {
        const link = makeElement('a', 'biede-fye__primary-link', this.labels.nextButton);
        link.href = edition.url;
        this.nextResult.append(link);
      }

      this.renderNextImage(target.model);
    }

    imageCandidates(model) {
      if (!model) return [];
      const edition = this.primaryEdition(model);
      return [
        model.inUseImage ? { src: model.inUseImage, position: '50% 50%' } : null,
        model.fallbackStyleImage ? { src: model.fallbackStyleImage, position: model.fallbackStylePosition || '50% 50%' } : null,
        edition?.image ? { src: edition.image, position: '50% 50%' } : null
      ].filter(Boolean);
    }

    preloadImage(candidate) {
      return new Promise((resolve, reject) => {
        const probe = new Image();
        probe.decoding = 'async';
        probe.onload = () => resolve(candidate);
        probe.onerror = reject;
        probe.src = candidate.src;
      });
    }

    async renderNextImage(model) {
      if (!this.nextGrid || !this.nextMedia || !this.nextImage) return;
      const requestId = ++this.nextImageRequest;
      this.nextImage.classList.add('is-loading');

      for (const candidate of this.imageCandidates(model)) {
        try {
          await this.preloadImage(candidate);
          if (requestId !== this.nextImageRequest) return;
          this.nextImage.src = candidate.src;
          this.nextImage.alt = `${model.name}${this.labels.styleAltSuffix || ''}`;
          this.nextImage.style.objectPosition = candidate.position;
          this.nextMedia.hidden = false;
          this.nextGrid.classList.remove('is-image-unavailable');
          requestAnimationFrame(() => {
            if (requestId === this.nextImageRequest) this.nextImage.classList.remove('is-loading');
          });
          return;
        } catch (error) {
          // Try the next verified candidate: Admin image, approved fallback, product image.
        }
      }

      if (requestId !== this.nextImageRequest) return;
      this.nextImage.removeAttribute('src');
      this.nextImage.alt = '';
      this.nextImage.classList.remove('is-loading');
      this.nextMedia.hidden = true;
      this.nextGrid.classList.add('is-image-unavailable');
    }
  }

  // BIÉDE FIND YOUR ELEMENT photo and header fit fix v2026-09-11-1
  let headerTrackingStarted = false;
  const initialise = (scope = document) => {
    if (!headerTrackingStarted && document.querySelector(ROOT_SELECTOR)) {
      const header = document.querySelector('.header-wrapper');
      const main = document.getElementById('MainContent');
      if (header && main) {
        const syncHeaderHeight = () => {
          main.style.setProperty('--biede-fye-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
        };
        syncHeaderHeight();
        if ('ResizeObserver' in window) {
          new ResizeObserver(syncHeaderHeight).observe(header);
        } else {
          window.addEventListener('resize', syncHeaderHeight);
        }
        headerTrackingStarted = true;
      }
    }
    scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      if (root.dataset.biedeFindYourElementReady === 'true') return;
      root.dataset.biedeFindYourElementReady = 'true';
      new BiedeFindYourElement(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
